export default __webpack_public_path__ + "static/media/bg_Dot.a6330ad8.png";